import React from 'react';
import { IndexCoordinatorDelegate } from "../IndexCoordinator";
import { ZoneViewControllerDelegate, ZoneViewController } from "../../Screen/Zone/ZoneViewController";
import { TableGenericViewControllerDelegate, TableGenericViewController } from "../../Screen/TableGeneric/TableGenericViewController";
import { TableGenericViewModel } from "../../Screen/TableGeneric/TableGenericViewModel";
import { ZoneViewModel } from '../../Screen/Zone/ZoneViewModel';
import ProtectedRoute from '../../Components/ProtectedRoute';

export class ZoneCoordinator implements IndexCoordinatorDelegate, ZoneViewControllerDelegate, TableGenericViewControllerDelegate {

    getRoute(): JSX.Element[] {
        return [
            this.routeTable(),
            this.routeForm()
        ]
    }

    private routeTable(): JSX.Element {
        var viewModel = new TableGenericViewModel("gepzona")
        return (<ProtectedRoute requiredPermissions={['dengue.zona.*']} path="/:base/dengue/zona" exact={true} component={(props: any) => {
            return (<TableGenericViewController
                permissions={{
                    add: 'dengue.zona.adicionar',
                    edit: 'dengue.zona.editar',
                    delete: 'dengue.zona.excluir',
                }}
                navigation={props}
                viewModel={viewModel}
                delegate={this}
                title={"Zona"}
            />)
        }} />)
    }

    private routeForm(): JSX.Element {
        var viewModel = new ZoneViewModel()
        return (<ProtectedRoute requiredPermissions={['dengue.zona.adicionar', 'dengue.zona.editar']} path="/:base/dengue/zona/cad/:id" exact={true} component={(props: any) => {
            var idPk = props.match.params.id
            return (<ZoneViewController
                navigation={props}
                viewModel={viewModel}
                delegate={this}
                idPrimary={idPk}
            />)
        }} />)
    }

    tapDimiss(navigation: any): void {
        navigation.history.goBack();
    }

    add(navigation: any, viewModel: TableGenericViewModel): void {
        if (viewModel.getTable() == "gepzona") {
            navigation.history.push(`zona/cad/0`);
            return;
        }
    }

    edit(navigation: any, idSelection: number, viewModel: TableGenericViewModel): void {
        if (viewModel.getTable() == "gepzona") {
            navigation.history.push(`zona/cad/${idSelection}`);
            return;
        }
    }

}